/**
 * Theme Store - Global Dark/Light Mode Management
 *
 * Uses cookie for persistence (synced with PHP server-side rendering)
 * This eliminates theme flash on page load since PHP reads cookie directly
 *
 * Usage in templates:
 * - Get theme: $store.theme.current
 * - Toggle: $store.theme.toggle()
 * - Check: x-show="$store.theme.current === 'dark'"
 */

/**
 * Get cookie value by name
 */
function getCookie(name) {
  const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  return match ? match[2] : null;
}

/**
 * Set cookie with 1 year expiry
 */
function setCookie(name, value) {
  const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
  document.cookie = `${name}=${value};path=/;expires=${expires};SameSite=Lax`;
}

export default {
  // Read from document attribute (set by PHP from cookie) - no flash!
  current: document.documentElement.getAttribute('data-theme') || 'light',

  /**
   * Initialize theme on page load
   */
  init() {
    // Sync with cookie if exists (in case document attribute wasn't set)
    const cookieTheme = getCookie('theme');
    if (cookieTheme && (cookieTheme === 'light' || cookieTheme === 'dark')) {
      this.current = cookieTheme;
    }

    // Ensure document has correct attribute
    document.documentElement.setAttribute('data-theme', this.current);
  },

  /**
   * Toggle between light and dark theme
   */
  toggle() {
    this.current = this.current === 'light' ? 'dark' : 'light';
    setCookie('theme', this.current);
    document.documentElement.setAttribute('data-theme', this.current);
  },

  /**
   * Set specific theme
   * @param {string} theme - 'light' or 'dark'
   */
  set(theme) {
    if (theme !== 'light' && theme !== 'dark') return;
    this.current = theme;
    setCookie('theme', this.current);
    document.documentElement.setAttribute('data-theme', this.current);
  },

  /**
   * Check if current theme is dark
   * @returns {boolean}
   */
  get isDark() {
    return this.current === 'dark';
  },

  /**
   * Check if current theme is light
   * @returns {boolean}
   */
  get isLight() {
    return this.current === 'light';
  },
};
